function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    window.cartItemLoaderOn(this);
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    window.cartItemLoaderOn(this);
    const input = this.input;
    const previousValue = input.value;
    let currentValue = parseInt(input.value, 10);
    const minValue = parseInt(input.dataset.min, 10);
    const stepValue = parseInt(input.step, 10);

    if (event.target.name === 'plus') {
      if (currentValue < minValue) {
        input.value = minValue;
      } else {
        input.value = currentValue + stepValue;
      }
    } else if (event.target.name === 'minus') {
      if (currentValue > minValue) {
        input.value = currentValue - stepValue;
      }
    }

    if (previousValue !== input.value) {
      input.dispatchEvent(this.changeEvent);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      if (document.querySelector('.mobile-facets__main details')) {
        document.querySelector('.mobile-facets__main details').setAttribute('open', true);
      }
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      // details.removeAttribute('open');
      // details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.stickyUpdateInfo();
    }
  }

  stickyUpdateInfo() {
    const variant = this.currentVariant;
    const stickyAtc = document.getElementById('sticky-atc');
    const stickyVariant = document.querySelector('.js-sticky-variant');
    const stickyPrice = document.querySelector('.js-sticky-price');
    const stickyBtn = document.querySelector('.js-sticky-atc-btn');
    const stickyImg = document.querySelector('.sticky-atc__product img');
    
    if (stickyImg) {
      stickyImg.src = variant.featured_image.src + '&width=100';
    }
    if (stickyAtc) {
      stickyVariant.textContent = variant.title;
    }
    
    // Update sticky price with subscription discount (same logic as main PDP price)
    // Use setTimeout to ensure renderProductInfo() has updated the DOM first
    setTimeout(() => {
      if (stickyPrice) {
        const stickyPriceOrigin = document.querySelector('.js-sticky-price-origin');
        
        // First, try to get subscription price from main price element's data attributes
        const mainPriceElement = document.querySelector('.product-price__price[data-suscribe-time]');
        let subscriptionPrice = null;
        let subscriptionPriceRaw = null;
        let variantPriceRaw = null;
        
        if (mainPriceElement) {
          const subscribeTimeStr = mainPriceElement.getAttribute('data-suscribe-time');
          if (subscribeTimeStr) {
            subscriptionPrice = subscribeTimeStr;
            // Extract numeric value for raw price
            subscriptionPriceRaw = subscribeTimeStr.replace(/[^0-9.]/g, '');
          }
        }
        
        // If not found, try to get from sticky price element's own data attributes (set in Liquid)
        if (!subscriptionPrice && stickyPrice.hasAttribute('data-subscription-price')) {
          subscriptionPrice = stickyPrice.getAttribute('data-subscription-price');
          subscriptionPriceRaw = stickyPrice.getAttribute('data-subscription-price-raw');
        }
        
        // Get variant price raw value
        variantPriceRaw = stickyPrice.getAttribute('data-variant-price-raw') || 
                         (variant.price ? (variant.price / 100).toFixed(2) : null);
        
        // If subscription price exists, use it; otherwise use regular variant price
        if (subscriptionPrice && subscriptionPriceRaw) {
          // Show subscription price with strikethrough original
          stickyPrice.textContent = subscriptionPrice.includes('$') ? subscriptionPrice : `$${parseFloat(subscriptionPriceRaw).toFixed(2)}`;
          stickyPrice.style.color = '#C1472A'; // Ensure subscription color
          
          // Show and update original price
          if (stickyPriceOrigin && variantPriceRaw) {
            stickyPriceOrigin.textContent = `$${parseFloat(variantPriceRaw).toFixed(2)}`;
            stickyPriceOrigin.classList.remove('tw-hidden');
          }
        } else {
          // No subscription discount - show regular price, hide original
          const variantPriceAttr = stickyPrice.getAttribute('data-variant-price');
          if (variantPriceAttr) {
            stickyPrice.textContent = variantPriceAttr;
          } else if (variant.price && window.Shopify && window.Shopify.formatMoney) {
            stickyPrice.textContent = window.Shopify.formatMoney(variant.price);
          }
          stickyPrice.style.color = '#C1472A'; // Keep color consistent
          
          // Hide original price
          if (stickyPriceOrigin) {
            stickyPriceOrigin.classList.add('tw-hidden');
          }
        }
      }
    }, 100);
    
    if (!variant.available) {
      document.body.classList.remove('sticky-visible');
      stickyBtn.setAttribute('disabled', true);
    } else {
      stickyBtn.removeAttribute('disabled');
      document.body.classList.add('sticky-visible');
    }
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });

    fieldsets.forEach((fieldset, idx) => {
      const selectedValueSpan = fieldset.querySelector('[data-selected-value]');
      if (selectedValueSpan) {
        selectedValueSpan.textContent = this.options[idx] || '';
      }
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) => {
      if (mediaGallery && typeof mediaGallery.setActiveMedia === 'function') {
        const mediaId = `${this.dataset.section}-${this.currentVariant.featured_media.id}`;
        mediaGallery.setActiveMedia(mediaId, true);
      } else {
        console.error('mediaGallery is not initialized or does not have setActiveMedia function.');
      }
    });

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        const buttonPrice = document.getElementById(`sticky-price-${this.dataset.section}`);
        const buttonPricesource = html.getElementById(
          `sticky-price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        if (buttonPrice && buttonPricesource) buttonPrice.innerHTML = buttonPricesource.innerHTML;

        if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });

        // Re-trigger metafield pricing updates after price HTML is replaced
        // This ensures metafield-based discounts are properly displayed
        setTimeout(() => {
          // Trigger Skio price update if available
          const skioEvent = new CustomEvent('skio::update-selling-plan', {
            bubbles: true,
            composed: true,
            detail: {
              variant: this.currentVariant,
              productId: this.currentVariant.product_id,
              sellingPlan: null, // Will be determined by Skio component
            },
          });
          document.dispatchEvent(skioEvent);

          // Re-run product page pricing scripts that read data attributes
          if (typeof ancestralApplyWidgetRecharge === 'function') {
            ancestralApplyWidgetRecharge();
          }

          // Re-trigger subscription price display scripts
          const customSale = document.querySelector('.custom_sale');
          if (customSale) {
            const subscribeTimeValue = customSale.getAttribute('data-suscribe-time');
            const discountValue = customSale.getAttribute('data-suscribe');
            const oneTimeValue = customSale.getAttribute('data-one-time');
            
            // Update subscription price display
            const priceSpan = document.querySelector('.rc-option__price.rc_widget__price.rc_widget__price--subsave');
            const discountSpan = document.querySelector('span.rc-option__discount.rc_widget__option__discount');
            if (priceSpan && subscribeTimeValue) {
              priceSpan.innerHTML = subscribeTimeValue;
            }
            if (discountSpan && discountValue) {
              discountSpan.innerHTML = discountValue;
            }

            // Update one-time price display
            const onetimePrice = document.querySelector('span.rc-option__price.rc_widget__price.rc_widget__price--onetime');
            if (onetimePrice && oneTimeValue) {
              onetimePrice.innerHTML = oneTimeValue;
            }
          }

          // Update collection/product grid prices with metafield discounts
          if (typeof window.updateMetafieldPricing === 'function') {
            window.updateMetafieldPricing();
          }
        }, 100);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

/**
 * Helper function to update metafield-based pricing across the site
 * This ensures metafield discounts are properly displayed on collections and PDPs
 */
window.updateMetafieldPricing = function() {
  // Check if we're on a PDP (product page) - subscription_price always takes precedence on PDP
  const isProductPage = document.body.classList.contains('template-product') || 
                        document.querySelector('.product-main') !== null;
  
  // Update product grid prices (collections)
  const priceElements = document.querySelectorAll('.product-price__price[data-one-time], .product-price__price[data-suscribe-time], .price-item--sale[data-one-time]');
  priceElements.forEach((el) => {
    const oneTimeStr = el.getAttribute('data-one-time');
    const subscribeTimeStr = el.getAttribute('data-suscribe-time');
    const subscriptionDiscount = el.getAttribute('data-subscription-discount');
    const onetimeDiscount = el.getAttribute('data-onetime-discount');
    
    // Check if subscription toggle is active (collection pages only)
    const subscriptionToggle = document.getElementById('show-subscribe-price') || 
                                document.getElementById('boost-collections-subscription-toggle');
    const isSubscription = subscriptionToggle && subscriptionToggle.checked;
    
    // On PDP: Always use subscription_price metafield if it exists (subscription takes precedence)
    // On Collections: Respect the toggle state
    const shouldUseSubscription = isProductPage ? (subscribeTimeStr && subscriptionDiscount) : (isSubscription && subscribeTimeStr);
    
    if (shouldUseSubscription && subscribeTimeStr) {
      // Show subscription price
      const priceText = subscribeTimeStr.replace(/[^0-9.]/g, '');
      if (priceText) {
        el.textContent = subscribeTimeStr.includes('$') ? subscribeTimeStr : `$${parseFloat(priceText).toFixed(2)}`;
        el.style.color = '#bd472a';
        
        // Update discount badge - ALWAYS use subscription discount on PDP when subscription_price metafield exists
        const discountBadge = el.closest('.price__container')?.querySelector('.product-collection.savings.text, .discount-hide-pecentage, .badge[data-discount]');
        if (discountBadge && subscriptionDiscount) {
          discountBadge.textContent = `Save ${subscriptionDiscount}%`;
          discountBadge.setAttribute('data-discount-percentage', subscriptionDiscount);
          discountBadge.setAttribute('data-subscription-discount-percentage', subscriptionDiscount);
          if (discountBadge.hasAttribute('data-discount')) {
            discountBadge.setAttribute('data-discount', subscriptionDiscount);
          }
        }
      }
    } else if (oneTimeStr && !isProductPage) {
      // Show one-time price (only on collection pages, not PDP)
      const priceText = oneTimeStr.replace(/[^0-9.]/g, '');
      if (priceText) {
        el.textContent = oneTimeStr.includes('$') ? oneTimeStr : `$${parseFloat(priceText).toFixed(2)}`;
        el.style.color = '#1f0a00';
        
        // Update discount badge if it exists
        const discountBadge = el.closest('.price__container')?.querySelector('.product-collection.savings.text, .discount-hide-pecentage, .badge[data-discount]');
        if (discountBadge && onetimeDiscount) {
          discountBadge.textContent = `Save ${onetimeDiscount}%`;
          if (discountBadge.hasAttribute('data-discount-percentage')) {
            discountBadge.setAttribute('data-discount-percentage', onetimeDiscount);
          }
          if (discountBadge.hasAttribute('data-discount')) {
            discountBadge.setAttribute('data-discount', onetimeDiscount);
          }
        }
      }
    }
  });
  
  // Also update sticky ATC price on PDP
  if (isProductPage) {
    const stickyPrice = document.querySelector('.js-sticky-price');
    const stickyPriceOrigin = document.querySelector('.js-sticky-price-origin');
    const mainPriceElement = document.querySelector('.product-price__price[data-suscribe-time]');
    
    if (stickyPrice && mainPriceElement) {
      const subscribeTimeStr = mainPriceElement.getAttribute('data-suscribe-time');
      const subscriptionDiscount = mainPriceElement.getAttribute('data-subscription-discount');
      
      // On PDP, always prioritize subscription price if metafield exists
      if (subscribeTimeStr && subscriptionDiscount) {
        const subscriptionPriceRaw = subscribeTimeStr.replace(/[^0-9.]/g, '');
        stickyPrice.textContent = subscribeTimeStr.includes('$') ? subscribeTimeStr : `$${parseFloat(subscriptionPriceRaw).toFixed(2)}`;
        stickyPrice.style.color = '#C1472A';
        
        // Show and update original price (strikethrough)
        if (stickyPriceOrigin) {
          const variantPriceRaw = stickyPrice.getAttribute('data-variant-price-raw');
          if (variantPriceRaw) {
            stickyPriceOrigin.textContent = `$${parseFloat(variantPriceRaw).toFixed(2)}`;
            stickyPriceOrigin.classList.remove('tw-hidden');
          } else {
            // Fallback: get from main price element's original price
            const mainPriceOrigin = document.querySelector('.product-price__price_origin');
            if (mainPriceOrigin) {
              stickyPriceOrigin.textContent = mainPriceOrigin.textContent.trim();
              stickyPriceOrigin.classList.remove('tw-hidden');
            }
          }
        }
      } else if (stickyPrice.hasAttribute('data-variant-price')) {
        // Fallback to variant price (no discount)
        stickyPrice.textContent = stickyPrice.getAttribute('data-variant-price');
        stickyPrice.style.color = '#C1472A';
        
        // Hide original price when no discount
        if (stickyPriceOrigin) {
          stickyPriceOrigin.classList.add('tw-hidden');
        }
      }
    }
  }
};

// Re-run pricing updates when collection content is loaded via AJAX
document.addEventListener('ajaxinate:loaded', function() {
  setTimeout(window.updateMetafieldPricing, 100);
});

// Re-run pricing updates when Shopify sections are loaded
document.addEventListener('shopify:section:load', function() {
  setTimeout(window.updateMetafieldPricing, 100);
});

document.addEventListener('shopify:section:reloaded', function() {
  setTimeout(window.updateMetafieldPricing, 100);
});

// Run on initial page load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(window.updateMetafieldPricing, 200);
  });
} else {
  setTimeout(window.updateMetafieldPricing, 200);
}

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });

    fieldsets.forEach((fieldset, idx) => {
      const selectedValueSpan = fieldset.querySelector('[data-selected-value]');
      if (selectedValueSpan) {
        selectedValueSpan.textContent = this.options[idx] || '';
      }
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

// Defer external link processing to avoid blocking initial render
(function() {
  const processExternalLinks = () => {
    const links = document.links;
    const hostname = window.location.hostname;
    const excludeClass = 'btn-open-search-drawner';
    
    for (let i = 0, linksLength = links.length; i < linksLength; i++) {
      const link = links[i];
      if (link.hostname !== hostname && !link.classList.contains(excludeClass)) {
        link.target = '_blank';
        link.rel = 'noreferrer noopener';
      }
    }
  };
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processExternalLinks);
  } else {
    // Use requestIdleCallback if available, otherwise setTimeout
    if ('requestIdleCallback' in window) {
      requestIdleCallback(processExternalLinks, { timeout: 2000 });
    } else {
      setTimeout(processExternalLinks, 0);
    }
  }
})();

class UpsellProductCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeUpsellProduct(this.dataset.productId);
  }

  initializeUpsellProduct(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const upsellProduct = html.querySelector('upsell-product-cart');

        if (upsellProduct && upsellProduct.querySelectorAll('.cart__upsell').length > 0) {
          this.innerHTML = upsellProduct.innerHTML;
          this.classList.remove('!tw-hidden');

          new Swiper(this.querySelector('.upsell-swiper'), {
            slidesPerView: 2.1,
            spaceBetween: 14,
            loop: false,
            freeMode: true,
            mousewheel: {
              forceToAxis: true,
            },
          });
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}
customElements.define('upsell-product-cart', UpsellProductCart);

class ChangeCart extends HTMLElement {
  constructor() {
    super();
    this.selectPlan = this.selectPlan.bind(this);
  }

  connectedCallback() {
    this.querySelector('.change-label')?.addEventListener('click', this.selectPlan);
  }

  disconnectedCallback() {
    this.querySelector('.change-label')?.removeEventListener('click', this.selectPlan);
  }

  selectPlan(event) {
    const selectedId = event.currentTarget.dataset.sellingId;
    const qty = this.dataset.qty;
    const line = this.dataset.line;

    this.classList.add('has-loading');

    window.cartItemLoaderOn(this);

    fetch(`/cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        line: parseInt(line),
        quantity: parseInt(qty),
        selling_plan: selectedId,
      }),
    })
      .then((res) => res.json())
      .then(() => {
        const drawerSectionId = document.querySelector('cart-drawer');
        if (!drawerSectionId) return;

        return fetch(`${routes.cart_url}?section_id=cart-drawer`);
      })
      .then((response) => response?.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const newInner = html.querySelector('cart-drawer .drawer__inner');
        if (newInner) {
          document.querySelector('cart-drawer .drawer__inner').innerHTML = newInner.innerHTML;
        }
        this.classList.remove('has-loading');
      })
      .catch((err) => {
        console.error('Error updating selling plan:', err);
        this.classList.remove('has-loading');
      });
  }
}

customElements.define('item-change', ChangeCart);

// Debounced cart drawer refresh to prevent multiple simultaneous refreshes
let cartRefreshTimer = null;
let isCartRefreshing = false;
let pendingCartRefresh = false;

window.refreshCartDrawer = function (immediate = false) {
  // If already refreshing, mark as pending and return
  if (isCartRefreshing) {
    pendingCartRefresh = true;
    return;
  }

  // Debounce multiple calls unless immediate is true
  if (!immediate && cartRefreshTimer) {
    pendingCartRefresh = true;
    return;
  }

  const performRefresh = () => {
    if (isCartRefreshing) return;
    
    isCartRefreshing = true;
    pendingCartRefresh = false;

    // Start fetch immediately (network I/O), defer DOM updates
    fetch(`?/section_id=cart-drawer`)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.text();
      })
      .then((data) => {
        const html = new DOMParser().parseFromString(data, 'text/html');
        const cartDrawer = document.querySelector('cart-drawer .drawer__inner');
        const newcartDrawerData = html.querySelector('cart-drawer .drawer__inner');
        
        if (cartDrawer && newcartDrawerData) {
          // Use requestAnimationFrame for smoother DOM updates
          requestAnimationFrame(() => {
              cartDrawer.innerHTML = newcartDrawerData.innerHTML;

              // Cache DOM queries to avoid repeated lookups
              const cartCountSpan = document.querySelector('#CartCount span');
              if (cartCountSpan) {
                const countText = cartCountSpan.textContent.replace(/[()]/g, '');
                const bubbles = document.querySelectorAll('.cart-count-bubble span');
                for (let i = 0, len = bubbles.length; i < len; i++) {
                  bubbles[i].textContent = countText;
                }
              }
              
              // Cache body query
              const isCartPage = document.body.classList.contains('template-cart');
              if (!isCartPage) cartDrawer.classList.add('active');

              // Trigger single event (not both) to prevent double updates
              // Use a small delay to ensure DOM is fully updated
              setTimeout(() => {
                document.dispatchEvent(new CustomEvent('cart:updated', { 
                  bubbles: true,
                  cancelable: true 
                }));
                isCartRefreshing = false;
                
                // If there was a pending refresh, do it now
                if (pendingCartRefresh) {
                  pendingCartRefresh = false;
                  setTimeout(() => window.refreshCartDrawer(true), 50);
                }
              }, 10);
            });
          } else {
            isCartRefreshing = false;
          }
        })
        .catch((error) => {
          console.error('Failed to update cart drawer:', error);
          isCartRefreshing = false;
          pendingCartRefresh = false;
        });
  };

  if (immediate) {
    performRefresh();
  } else {
    // Debounce with a short delay for smoother experience
    if (cartRefreshTimer) {
      clearTimeout(cartRefreshTimer);
    }
    cartRefreshTimer = setTimeout(() => {
      cartRefreshTimer = null;
      performRefresh();
    }, 150); // Short debounce for smoother feel
  }
};

class FreeGiftLogic extends HTMLElement {
  constructor() {
    super();
    this.isProcessing = false;
    this.pendingOperations = new Set();
    this.debounceTimer = null;
    this.lastCheckTime = 0;
    this.MIN_CHECK_INTERVAL = 500; // Minimum 500ms between checks
    this.previousGiftState = false; // Track previous theme gift state to detect manual removal
    this.previousKiteGiftState = false; // Track previous Kite gift state to detect manual removal
    this.OPT_OUT_STORAGE_KEY = 'free_gift_opt_out'; // Key for sessionStorage
    this.PREVIOUS_STATE_KEY = 'free_gift_previous_state'; // Key for storing previous state
  }

  connectedCallback() {
    if (this.classList.contains('has-free-gift')) {
      const variantId = this.getAttribute('data-free-gift-variant-id') || this.dataset.freeGiftVariantId;
      
      // Restore previous state from sessionStorage if available
      this.restorePreviousState(variantId);
      
      // Initialize current states from data attributes
      const themeGiftAdded = this.getAttribute('data-free-gift-added') === 'true' || 
                             this.dataset.freeGiftAdded === 'true';
      const kiteGiftAdded = this.getAttribute('data-kite-gift-added') === 'true' || 
                            this.dataset.kiteGiftAdded === 'true';
      
      // Check if gift was removed by comparing with previous state
      const hadGiftBefore = this.previousGiftState || this.previousKiteGiftState;
      const hasGiftNow = themeGiftAdded || kiteGiftAdded;
      
      // If we had a gift before but don't have it now, and we're not processing a removal, user opted out
      if (hadGiftBefore && !hasGiftNow && !this.pendingOperations.has('remove')) {
        console.log('[Free Gift] Element reconnected: Gift was removed, setting opt-out flag');
        this.setOptOutFlag(true);
      }
      
      // Update previous states to current state
      this.previousGiftState = themeGiftAdded;
      this.previousKiteGiftState = kiteGiftAdded;
      this.savePreviousState(variantId);
      
      console.log('[Free Gift] Element connected, initial state:', {
        themeGiftAdded,
        kiteGiftAdded,
        previousGiftState: this.previousGiftState,
        previousKiteGiftState: this.previousKiteGiftState,
        hadGiftBefore,
        hasGiftNow,
        userOptedOut: this.getOptOutFlag()
      });
      
      // Safari fix: Use requestAnimationFrame for better timing
      requestAnimationFrame(() => {
        // Additional delay for Safari to ensure data attributes are set
        setTimeout(() => {
      this.runFreeGiftLogic();
        }, 150);
      });
      
      // Listen for cart updates to re-check for Kite items
      // Safari fix: Bind handler to preserve 'this' context
      this.cartUpdateHandler = this.handleCartUpdate.bind(this);
      
      document.addEventListener('cart:updated', this.cartUpdateHandler);
      document.addEventListener('cart:refresh', this.cartUpdateHandler);
      
      // Safari fix: Also listen for DOM mutations in case element is replaced
      if (typeof MutationObserver !== 'undefined') {
        this.observeDataAttributes();
      }
    }
  }

  /**
   * Restore previous state from sessionStorage
   */
  restorePreviousState(variantId) {
    try {
      if (!variantId) return;
      const key = `${this.PREVIOUS_STATE_KEY}_${variantId}`;
      const stored = sessionStorage.getItem(key);
      if (stored) {
        const state = JSON.parse(stored);
        this.previousGiftState = state.themeGiftAdded || false;
        this.previousKiteGiftState = state.kiteGiftAdded || false;
        console.log('[Free Gift] Restored previous state from sessionStorage:', state);
      }
    } catch (e) {
      console.error('[Free Gift] Error restoring previous state:', e);
    }
  }

  /**
   * Save previous state to sessionStorage
   */
  savePreviousState(variantId) {
    try {
      if (!variantId) return;
      const key = `${this.PREVIOUS_STATE_KEY}_${variantId}`;
      const state = {
        themeGiftAdded: this.previousGiftState,
        kiteGiftAdded: this.previousKiteGiftState,
        timestamp: Date.now()
      };
      sessionStorage.setItem(key, JSON.stringify(state));
    } catch (e) {
      console.error('[Free Gift] Error saving previous state:', e);
    }
  }

  handleCartUpdate() {
    // Check if element still exists
    if (!document.body.contains(this)) {
      return;
    }
    
    console.log('[Free Gift] Cart update detected');
    
    // Check actual cart state to detect manual removals more reliably
    this.checkCartStateForRemovals();
    
    // Debounce cart updates to prevent multiple simultaneous checks
    // Increased delay slightly for mobile to allow DOM to fully update
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    
    this.debounceTimer = setTimeout(() => {
      // Check again if element still exists
      if (!document.body.contains(this)) {
        return;
      }
      
      // Safari fix: Re-query element in case it was replaced
      const currentElement = document.querySelector('free-gift-logic.has-free-gift');
      if (currentElement && currentElement === this) {
        // Refresh data attributes from the element (they get updated when cart refreshes)
        // Increased delay for mobile to ensure DOM is fully updated
        requestAnimationFrame(() => {
          setTimeout(() => {
            // Final check before running logic
            if (document.body.contains(this)) {
              // detectManualRemoval is now handled inside runFreeGiftLogic
              // to ensure it runs synchronously before add logic
              this.runFreeGiftLogic();
            }
          }, 250); // Increased from 150ms to 250ms for mobile stability
        });
      }
    }, 250); // Increased from 150ms to 250ms for mobile stability
  }

  /**
   * Check actual cart state to detect if gift was manually removed
   * This is more reliable than just checking data attributes
   */
  checkCartStateForRemovals() {
    const variantId = this.getAttribute('data-free-gift-variant-id') || this.dataset.freeGiftVariantId;
    if (!variantId) return;
    
    // Only check if we're not currently processing a removal
    if (this.pendingOperations.has('remove')) {
      return;
    }
    
    // Fetch cart to check actual state
    fetch(window.Shopify.routes.root + 'cart.js')
      .then((response) => {
        if (!response.ok) {
          return;
        }
        return response.json();
      })
      .then((cart) => {
        if (!cart) return;
        
        // Check if any version of free gift exists in cart
        const giftInCart = cart.items.find((item) => {
          const isSameVariant = item.variant_id.toString() === variantId.toString();
          return isSameVariant;
        });
        
        const kiteGiftInCart = giftInCart && 
                               giftInCart.line_level_discount_allocations && 
                               giftInCart.line_level_discount_allocations.length > 0 &&
                               (!giftInCart.properties || 
                               !giftInCart.properties._is_free_gift ||
                               giftInCart.properties._is_free_gift !== 'true');
        
        const themeGiftInCart = giftInCart && 
                                giftInCart.properties && 
                                (giftInCart.properties._is_free_gift === true || 
                                 giftInCart.properties._is_free_gift === 'true');
        
        // If we had a gift before but it's not in cart now, user opted out
        const hadGiftBefore = this.previousGiftState || this.previousKiteGiftState;
        const hasGiftNow = themeGiftInCart || kiteGiftInCart;
        
        if (hadGiftBefore && !hasGiftNow) {
          console.log('[Free Gift] Cart state check: Gift was manually removed, setting opt-out flag');
          this.setOptOutFlag(true);
        }
      })
      .catch((error) => {
        console.error('[Free Gift] Error checking cart state:', error);
      });
  }

  /**
   * Detect if the free gift was manually removed by the user
   * If it was previously added and is now gone (and we didn't remove it programmatically),
   * mark it as opted out. Also detects when Kite gift is removed.
   */
  detectManualRemoval() {
    const currentGiftAdded = this.getAttribute('data-free-gift-added') === 'true' || 
                             this.dataset.freeGiftAdded === 'true';
    const currentKiteGiftAdded = this.getAttribute('data-kite-gift-added') === 'true' || 
                                 this.dataset.kiteGiftAdded === 'true';
    const variantId = this.getAttribute('data-free-gift-variant-id') || this.dataset.freeGiftVariantId;
    
    // Track previous Kite gift state (initialize if not set)
    if (this.previousKiteGiftState === undefined) {
      this.previousKiteGiftState = currentKiteGiftAdded;
    }
    
    // If either theme gift or Kite gift was previously present but is now removed,
    // and we're not currently processing a removal, check if user opted out
    const wasGiftPresent = this.previousGiftState || this.previousKiteGiftState;
    const isGiftPresent = currentGiftAdded || currentKiteGiftAdded;
    
    if (wasGiftPresent && !isGiftPresent && !this.pendingOperations.has('remove')) {
      // Fetch cart to verify it was actually removed (not just a data attribute issue)
      fetch(window.Shopify.routes.root + 'cart.js')
        .then((response) => {
          if (!response.ok) {
            return;
          }
          return response.json();
        })
        .then((cart) => {
          if (!cart) return;
          
          // Check if any version of free gift still exists in cart
          const giftStillExists = cart.items.some((item) => {
            const isSameVariant = item.variant_id.toString() === variantId.toString();
            const isThemeGift = item.properties && 
                              (item.properties._is_free_gift === true || 
                               item.properties._is_free_gift === 'true');
            const isKiteGift = item.line_level_discount_allocations && 
                              item.line_level_discount_allocations.length > 0 &&
                              (!item.properties || 
                               !item.properties._is_free_gift ||
                               item.properties._is_free_gift !== 'true');
            return isSameVariant && (isThemeGift || isKiteGift);
          });
          
          // If gift was removed and we didn't remove it programmatically, user opted out
          if (!giftStillExists && wasGiftPresent) {
            this.setOptOutFlag(true);
          }
        })
        .catch(() => {
          // Silently fail - this is just for detection
        });
    }
    
    // Update previous states for next check
    this.previousGiftState = currentGiftAdded;
    this.previousKiteGiftState = currentKiteGiftAdded;
  }

  /**
   * Get the opt-out flag from sessionStorage
   */
  getOptOutFlag() {
    try {
      const variantId = this.getAttribute('data-free-gift-variant-id') || this.dataset.freeGiftVariantId;
      const key = `${this.OPT_OUT_STORAGE_KEY}_${variantId}`;
      return sessionStorage.getItem(key) === 'true';
    } catch (e) {
      return false;
    }
  }

  /**
   * Set the opt-out flag in sessionStorage
   */
  setOptOutFlag(optedOut) {
    try {
      const variantId = this.getAttribute('data-free-gift-variant-id') || this.dataset.freeGiftVariantId;
      const key = `${this.OPT_OUT_STORAGE_KEY}_${variantId}`;
      if (optedOut) {
        sessionStorage.setItem(key, 'true');
        console.log(`[Free Gift] Opt-out flag SET for variant ${variantId} (key: ${key})`);
      } else {
        sessionStorage.removeItem(key);
        console.log(`[Free Gift] Opt-out flag CLEARED for variant ${variantId} (key: ${key})`);
      }
    } catch (e) {
      console.error('[Free Gift] Error setting opt-out flag:', e);
    }
  }

  observeDataAttributes() {
    // Safari fix: Watch for data attribute changes
    if (this.dataObserver) {
      this.dataObserver.disconnect();
    }
    
    this.dataObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName && mutation.attributeName.startsWith('data-')) {
          // Data attribute changed, re-run logic
          setTimeout(() => {
            this.runFreeGiftLogic();
          }, 100);
        }
      });
    });
    
    this.dataObserver.observe(this, {
      attributes: true,
      attributeFilter: ['data-free-gift-added', 'data-kite-gift-added', 'data-free-gift-key', 'data-current-subtotal']
    });
  }

  disconnectedCallback() {
    // Clean up event listeners
    if (this.cartUpdateHandler) {
      document.removeEventListener('cart:updated', this.cartUpdateHandler);
      document.removeEventListener('cart:refresh', this.cartUpdateHandler);
    }
    
    // Safari fix: Clean up mutation observer
    if (this.dataObserver) {
      this.dataObserver.disconnect();
      this.dataObserver = null;
    }
  }

  runFreeGiftLogic() {
    // Check if element still exists (important for mobile when DOM updates)
    if (!document.body.contains(this)) {
      return;
    }
    
    // Prevent too frequent checks
    const now = Date.now();
    if (now - this.lastCheckTime < this.MIN_CHECK_INTERVAL && this.isProcessing) {
      return;
    }
    this.lastCheckTime = now;

    if (this.isProcessing) {
      // Queue this operation if we're already processing
      // Increased retry delay for mobile
      setTimeout(() => {
        if (document.body.contains(this)) {
          this.runFreeGiftLogic();
        }
      }, 300); // Increased from 200ms to 300ms for mobile
      return;
    }

    // Safari fix: Use getAttribute for better compatibility
    const kiteGiftAdded = this.getAttribute('data-kite-gift-added') === 'true' || this.dataset.kiteGiftAdded === 'true';
    const themeGiftAdded = this.getAttribute('data-free-gift-added') === 'true' || this.dataset.freeGiftAdded === 'true';
    
    // Safari fix: Handle potential undefined/null values
    const thresholdStr = this.getAttribute('data-free-product-threshold') || this.dataset.freeProductThreshold || '0';
    const subtotalStr = this.getAttribute('data-current-subtotal') || this.dataset.currentSubtotal || '0';
    const threshold = Number(thresholdStr.toString().trim());
    const currentSubtotal = Number(subtotalStr.toString().trim());

    // DEBUG: Log current state
    console.log('[Free Gift Debug]', {
      kiteGiftAdded,
      themeGiftAdded,
      previousKiteGiftState: this.previousKiteGiftState,
      previousGiftState: this.previousGiftState,
      threshold,
      currentSubtotal,
      userOptedOut: this.getOptOutFlag(),
      pendingOperations: Array.from(this.pendingOperations)
    });

    // CRITICAL: Check if gift was manually removed BEFORE running add logic
    // If Kite gift was present but is now gone, user opted out
    const wasKiteGiftPresent = this.previousKiteGiftState === true;
    if (wasKiteGiftPresent && !kiteGiftAdded && !this.pendingOperations.has('remove')) {
      // Kite gift was removed - user opted out
      console.log('[Free Gift] Kite gift was manually removed, setting opt-out flag');
      this.setOptOutFlag(true);
    }
    
    // If theme gift was present but is now gone (and we didn't remove it), user opted out
    const wasThemeGiftPresent = this.previousGiftState === true;
    if (wasThemeGiftPresent && !themeGiftAdded && !this.pendingOperations.has('remove')) {
      // Theme gift was removed - user opted out
      console.log('[Free Gift] Theme gift was manually removed, setting opt-out flag');
      this.setOptOutFlag(true);
    }

    // Priority 1: If Kite has added the gift, ALWAYS remove theme version if it exists
    // Safari fix: Use getAttribute for better compatibility
    const giftKey = this.getAttribute('data-free-gift-key') || this.dataset.freeGiftKey;
    if (kiteGiftAdded && themeGiftAdded && giftKey) {
      this.removeFreeGift(giftKey);
      // Update previous states before returning
      this.previousGiftState = themeGiftAdded;
      this.previousKiteGiftState = kiteGiftAdded;
      return;
    }

    // Priority 2: If Kite version exists, NEVER add theme version
    if (kiteGiftAdded) {
      // Double-check by fetching cart to ensure we remove any theme gifts
      this.verifyAndRemoveThemeGifts();
      // Update previous states before returning
      this.previousGiftState = themeGiftAdded;
      this.previousKiteGiftState = kiteGiftAdded;
      return;
    }

    // Priority 3: Check if user has opted out (manually removed the free gift)
    const userOptedOut = this.getOptOutFlag();
    
    // If cart subtotal drops below threshold, clear the opt-out flag
    // This allows the gift to be offered again if user adds more items
    if (threshold > currentSubtotal) {
      if (userOptedOut) {
        console.log('[Free Gift] Clearing opt-out flag - subtotal dropped below threshold');
      }
      this.setOptOutFlag(false);
    }

    // Priority 4: Normal logic - add/remove based on threshold
    // BUT: Respect user's opt-out choice - don't re-add if they manually removed it
    const variantId = this.getAttribute('data-free-gift-variant-id') || this.dataset.freeGiftVariantId;
    if (threshold <= currentSubtotal && !themeGiftAdded && variantId && !userOptedOut) {
      console.log('[Free Gift] Adding free gift - threshold met and user has not opted out');
      this.addFreeGift(variantId);
    } else if (threshold <= currentSubtotal && !themeGiftAdded && variantId && userOptedOut) {
      // User has opted out - don't add even though threshold is met
      console.log('[Free Gift] NOT adding free gift - user has opted out (threshold met but user removed it)');
    } else if (threshold > currentSubtotal && themeGiftAdded && giftKey) {
      console.log('[Free Gift] Removing free gift - subtotal below threshold');
      this.removeFreeGift(giftKey);
    }
    
    // Update previous states for next check (AFTER all logic runs)
    this.previousGiftState = themeGiftAdded;
    this.previousKiteGiftState = kiteGiftAdded;
    
    // Save state to sessionStorage so it persists across element reconnections
    this.savePreviousState(variantId);
  }

  verifyAndRemoveThemeGifts() {
    // Prevent multiple simultaneous verifications
    if (this.pendingOperations.has('verify')) {
      return;
    }
    this.pendingOperations.add('verify');

    // Fetch cart to verify and remove any theme gifts that might exist
    // Safari fix: Use getAttribute for better compatibility
    const variantId = this.getAttribute('data-free-gift-variant-id') || this.dataset.freeGiftVariantId;
    if (!variantId) {
      this.pendingOperations.delete('verify');
      return;
    }

    fetch(window.Shopify.routes.root + 'cart.js')
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((cart) => {
        // Find theme-added free gifts (same variant with _is_free_gift property)
        const themeGifts = cart.items.filter((item) => {
          const isSameVariant = item.variant_id.toString() === variantId.toString();
          const isThemeGift = item.properties && 
                            (item.properties._is_free_gift === true || 
                             item.properties._is_free_gift === 'true');
          return isSameVariant && isThemeGift;
        });

        // Check if Kite version exists
        const kiteItem = cart.items.find((item) => {
          const isSameVariant = item.variant_id.toString() === variantId.toString();
          const hasDiscounts = item.line_level_discount_allocations && 
                               item.line_level_discount_allocations.length > 0;
          const isNotThemeGift = !item.properties || 
                                 !item.properties._is_free_gift ||
                                 item.properties._is_free_gift !== 'true';
          return isSameVariant && hasDiscounts && isNotThemeGift;
        });

        // If Kite version exists and theme version exists, remove theme version
        if (kiteItem && themeGifts.length > 0) {
          const updates = {};
          themeGifts.forEach((gift) => {
            updates[gift.key] = 0;
          });

          return fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ updates }),
          })
            .then((response) => {
              if (!response.ok) {
                throw new Error('Failed to remove theme free gifts');
              }
              return response.json();
            })
            .then(() => {
              console.log('Removed theme free gifts (Kite version exists)');
              window.refreshCartDrawer(true);
            });
        }
      })
      .catch((error) => {
        console.error('Error verifying/removing theme free gifts:', error);
      })
      .finally(() => {
        this.pendingOperations.delete('verify');
      });
  }

  addFreeGift(variantId) {
    if (this.isProcessing || this.pendingOperations.has('add')) {
      return;
    }
    
    // Check if element still exists (important for mobile when DOM updates quickly)
    if (!document.body.contains(this)) {
      return;
    }
    
    this.isProcessing = true;
    this.pendingOperations.add('add');

    // Double-check Kite hasn't added it before we add
    // Safari fix: Use getAttribute for better compatibility
    if (this.getAttribute('data-kite-gift-added') === 'true' || this.dataset.kiteGiftAdded === 'true') {
      this.isProcessing = false;
      this.pendingOperations.delete('add');
      return;
    }

    // Final check: fetch cart to verify Kite hasn't added it
    fetch(window.Shopify.routes.root + 'cart.js')
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((cart) => {
        // Check if element still exists after fetch (mobile DOM might have updated)
        if (!document.body.contains(this)) {
          this.isProcessing = false;
          this.pendingOperations.delete('add');
          return;
        }
        
        // Check if Kite version already exists
        const kiteItem = cart.items.find((item) => {
          const isSameVariant = item.variant_id.toString() === variantId.toString();
          const hasDiscounts = item.line_level_discount_allocations && 
                               item.line_level_discount_allocations.length > 0;
          const isNotThemeGift = !item.properties || 
                                 !item.properties._is_free_gift ||
                                 item.properties._is_free_gift !== 'true';
          return isSameVariant && hasDiscounts && isNotThemeGift;
        });

        if (kiteItem) {
          // Kite already added it, don't add theme version
          this.isProcessing = false;
          this.pendingOperations.delete('add');
          return;
        }

        // Check if theme gift already exists in cart
        const themeGiftExists = cart.items.some((item) => {
          const isSameVariant = item.variant_id.toString() === variantId.toString();
          const isThemeGift = item.properties && 
                            (item.properties._is_free_gift === true || 
                             item.properties._is_free_gift === 'true');
          return isSameVariant && isThemeGift;
        });

        if (themeGiftExists) {
          // Already added, don't add again
          this.isProcessing = false;
          this.pendingOperations.delete('add');
          return;
        }

        // Proceed with adding theme gift
    let formData = {
      items: [
        {
          id: variantId,
          quantity: 1,
          properties: { _is_free_gift: true },
        },
      ],
    };

        return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
            if (!response.ok) {
              // Try to get error details
              return response.text().then(text => {
                throw new Error(`Failed to add free gift: ${text}`);
              });
            }
        return response.json();
          })
          .then((data) => {
            // Check if element still exists after adding
            if (!document.body.contains(this)) {
              return;
            }
            
            // Clear opt-out flag since gift was successfully added programmatically
            // This allows the gift to be offered again if cart changes
            this.setOptOutFlag(false);
            
            // After adding, check once if Kite also added it (with a reasonable delay)
            setTimeout(() => {
              if (document.body.contains(this)) {
                this.checkAndRemoveIfKiteExists();
              }
            }, 800); // Single check after 800ms (enough time for Kite to process)
          });
      })
      .catch((error) => {
        console.error('Error adding free gift:', error);
        // Ensure processing flag is cleared on error
        this.isProcessing = false;
        this.pendingOperations.delete('add');
      })
      .finally(() => {
        // Only refresh if element still exists
        if (document.body.contains(this)) {
          // Add a small delay before refreshing to ensure cart API has processed
          // This is especially important on mobile where network can be slower
          setTimeout(() => {
            if (document.body.contains(this)) {
              this.isProcessing = false;
              this.pendingOperations.delete('add');
              window.refreshCartDrawer(true);
            }
          }, 200); // Small delay for mobile network latency
        } else {
          // Element was removed, just clear flags
          this.isProcessing = false;
          this.pendingOperations.delete('add');
        }
      });
  }

  removeFreeGift(giftKey) {
    if (this.isProcessing) return;
    if (!giftKey) return;
    
    this.isProcessing = true;
    this.pendingOperations.add('remove');

    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ updates: { [giftKey]: 0 } }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Failed to remove free gift');
        }
        return response.json();
      })
      .catch((error) => {
        console.error('Error removing free gift:', error);
      })
      .finally(() => {
        this.isProcessing = false;
        this.pendingOperations.delete('remove');
        // Update previous state - this was a programmatic removal, not user opt-out
        this.previousGiftState = false;
        // Use immediate refresh after remove operation
        window.refreshCartDrawer(true);
      });
  }

  checkAndRemoveIfKiteExists() {
    // Prevent multiple simultaneous checks
    if (this.pendingOperations.has('checkKite')) {
      return;
    }
    this.pendingOperations.add('checkKite');

    // Fetch current cart to check for Kite version
    // Safari fix: Use getAttribute for better compatibility
    const variantId = this.getAttribute('data-free-gift-variant-id') || this.dataset.freeGiftVariantId;
    
    if (!variantId) {
      this.pendingOperations.delete('checkKite');
      return;
    }
    
    fetch(window.Shopify.routes.root + 'cart.js')
      .then((response) => {
        // Safari fix: Check response status
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((cart) => {
        // Find theme-added free gifts
        const themeGifts = cart.items.filter((item) => {
          const isSameVariant = item.variant_id.toString() === variantId.toString();
          const isThemeGift = item.properties && 
                            (item.properties._is_free_gift === true || 
                             item.properties._is_free_gift === 'true');
          return isSameVariant && isThemeGift;
        });

        // Check if Kite version exists (same variant with discounts, without _is_free_gift)
        const kiteItem = cart.items.find((item) => {
          const isSameVariant = item.variant_id.toString() === variantId.toString();
          const hasDiscounts = item.line_level_discount_allocations && 
                               item.line_level_discount_allocations.length > 0;
          const isNotThemeGift = !item.properties || 
                                 !item.properties._is_free_gift ||
                                 item.properties._is_free_gift !== 'true';
          
          return isSameVariant && hasDiscounts && isNotThemeGift;
        });

        // If Kite version exists and theme version exists, remove theme version
        if (kiteItem && themeGifts.length > 0) {
          const updates = {};
          themeGifts.forEach((gift) => {
            updates[gift.key] = 0;
          });

          return fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ updates }),
          })
            .then((response) => {
              if (!response.ok) {
                throw new Error('Failed to remove theme free gift');
              }
              console.log('Kite free gift detected, removed theme version');
              window.refreshCartDrawer(true);
            });
        }
      })
      .catch((error) => {
        console.error('Error checking for Kite gift:', error);
      })
      .finally(() => {
        this.pendingOperations.delete('checkKite');
      });
  }
}

customElements.define('free-gift-logic', FreeGiftLogic);

/**
 * Checkout Protection: Remove theme-added free gifts before checkout navigation
 * This ensures theme version NEVER reaches checkout
 */
(function() {
  'use strict';

  // Get free gift variant ID from the free-gift-logic element
  // Safari fix: Use getAttribute for better compatibility
  function getFreeGiftVariantId() {
    const freeGiftLogic = document.querySelector('free-gift-logic');
    if (freeGiftLogic) {
      return freeGiftLogic.getAttribute('data-free-gift-variant-id') || freeGiftLogic.dataset.freeGiftVariantId || null;
    }
    return null;
  }

  // Remove all theme-added free gifts from cart
  function removeThemeFreeGiftsBeforeCheckout() {
    return new Promise((resolve, reject) => {
      const variantId = getFreeGiftVariantId();
      if (!variantId) {
        resolve();
        return;
      }

      fetch(window.Shopify.routes.root + 'cart.js')
        .then((response) => response.json())
        .then((cart) => {
          // Find all theme-added free gifts (same variant with _is_free_gift property)
          const themeGifts = cart.items.filter((item) => {
            const isSameVariant = item.variant_id.toString() === variantId.toString();
            const isThemeGift = item.properties && 
                              (item.properties._is_free_gift === true || 
                               item.properties._is_free_gift === 'true');
            return isSameVariant && isThemeGift;
          });

          if (themeGifts.length === 0) {
            resolve();
            return;
          }

          // Remove all theme gifts
          const updates = {};
          themeGifts.forEach((gift) => {
            updates[gift.key] = 0;
          });

          fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ updates }),
          })
            .then((response) => {
              if (!response.ok) {
                throw new Error('Failed to remove theme free gifts');
              }
              return response.json();
            })
            .then(() => {
              console.log('Removed theme free gifts before checkout');
              resolve();
            })
            .catch((error) => {
              console.error('Error removing theme free gifts:', error);
              reject(error);
            });
        })
        .catch((error) => {
          console.error('Error fetching cart:', error);
          reject(error);
        });
    });
  }

  // Intercept checkout button clicks
  function interceptCheckoutButtons() {
    // Safari fix: Use both capture and bubble phases for better compatibility
    const handleClick = function(e) {
      const checkoutBtn = e.target.closest('#CartDrawer-Checkout, #checkout, [href*="/checkout"], [name="checkout"]');
      if (checkoutBtn && !checkoutBtn.disabled && !checkoutBtn.hasAttribute('data-checkout-processed')) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        checkoutBtn.setAttribute('data-checkout-processed', 'true');
        
        removeThemeFreeGiftsBeforeCheckout()
          .then(() => {
            // Navigate to checkout after removal
            // Safari fix: Use setTimeout to ensure navigation happens
            setTimeout(() => {
              if (checkoutBtn.href) {
                window.location.href = checkoutBtn.href;
              } else if (checkoutBtn.closest('form')) {
                checkoutBtn.closest('form').submit();
              } else {
                window.location.href = '/checkout';
              }
            }, 50);
          })
          .catch(() => {
            // Even if removal fails, proceed to checkout (Kite should handle it)
            setTimeout(() => {
              if (checkoutBtn.href) {
                window.location.href = checkoutBtn.href;
              } else {
                window.location.href = '/checkout';
              }
            }, 50);
          });
      }
    };
    
    // Safari fix: Add listener in both phases
    document.addEventListener('click', handleClick, true);
    document.addEventListener('click', handleClick, false);

    // Also intercept form submissions
    document.addEventListener('submit', function(e) {
      const form = e.target;
      if (form && ((form.action && form.action.includes('/checkout')) || 
          form.querySelector('[name="checkout"]'))) {
        e.preventDefault();
        e.stopPropagation();
        
        removeThemeFreeGiftsBeforeCheckout()
          .then(() => {
            form.submit();
          })
          .catch(() => {
            // Proceed even if removal fails
            form.submit();
          });
      }
    }, true);
  }

  // Periodic check to ensure theme gifts are removed (only when needed)
  let periodicCheckInterval = null;
  let lastPeriodicCheck = 0;
  const PERIODIC_CHECK_INTERVAL = 5000; // Check every 5 seconds
  const MIN_PERIODIC_CHECK_GAP = 2000; // Minimum 2 seconds between checks
  let isPeriodicCheckRunning = false; // Prevent overlapping checks

  function startPeriodicCheck() {
    // Only start if not already running
    if (periodicCheckInterval) {
      return;
    }

    periodicCheckInterval = setInterval(function() {
      const now = Date.now();
      // Skip if we just checked recently or check is already running
      if (now - lastPeriodicCheck < MIN_PERIODIC_CHECK_GAP || isPeriodicCheckRunning) {
        return;
      }
      lastPeriodicCheck = now;
      isPeriodicCheckRunning = true;

      const variantId = getFreeGiftVariantId();
      if (!variantId) return;

      fetch(window.Shopify.routes.root + 'cart.js')
        .then((response) => {
          // Safari fix: Check response status
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json();
        })
        .then((cart) => {
          const themeGifts = cart.items.filter((item) => {
            const isSameVariant = item.variant_id.toString() === variantId.toString();
            const isThemeGift = item.properties && 
                              (item.properties._is_free_gift === true || 
                               item.properties._is_free_gift === 'true');
            return isSameVariant && isThemeGift;
          });

          // Check if Kite version exists
          const kiteItem = cart.items.find((item) => {
            const isSameVariant = item.variant_id.toString() === variantId.toString();
            const hasDiscounts = item.line_level_discount_allocations && 
                                 item.line_level_discount_allocations.length > 0;
            const isNotThemeGift = !item.properties || 
                                   !item.properties._is_free_gift ||
                                   item.properties._is_free_gift !== 'true';
            return isSameVariant && hasDiscounts && isNotThemeGift;
          });

          // Only act if both exist (Kite version AND theme version)
          if (kiteItem && themeGifts.length > 0) {
            const updates = {};
            themeGifts.forEach((gift) => {
              updates[gift.key] = 0;
            });

            return fetch(window.Shopify.routes.root + 'cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({ updates }),
            })
              .then((response) => {
                if (!response.ok) {
                  throw new Error('Failed to remove theme free gifts');
                }
                return response.json();
              })
              .then(() => {
                console.log('Periodic check: Removed theme free gifts (Kite version exists)');
                if (typeof window.refreshCartDrawer === 'function') {
                  window.refreshCartDrawer(true);
                }
              })
              .catch(() => {
                // Silently fail periodic checks
              })
              .finally(() => {
                isPeriodicCheckRunning = false;
              });
          } else {
            isPeriodicCheckRunning = false;
          }
        })
        .catch(() => {
          // Silently fail periodic checks
          isPeriodicCheckRunning = false;
        });
    }, PERIODIC_CHECK_INTERVAL);
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      interceptCheckoutButtons();
      startPeriodicCheck();
    });
  } else {
    interceptCheckoutButtons();
    startPeriodicCheck();
  }
})();

window.activeFilterCount = function () {
  const activeFilterElm = document.querySelectorAll('.active-facets.active-facets-desktop .active-facets__button');
  if (activeFilterElm) {
    const activeCount = document.querySelector('.mobile-facets__wrapper .active-count');
    if (activeCount) {
      if (activeFilterElm.length > 0) {
        activeCount.textContent = activeFilterElm.length;
        activeCount.classList.remove('tw-hidden');
      } else {
        activeCount.textContent = activeFilterElm.length;
        activeCount.classList.add('tw-hidden');
      }
    }
  }
};

const close_btn = document.querySelector('.mobile-facets__header-inner .mobile-facets__close');
if (close_btn) {
  close_btn.addEventListener('click', () => {
    document.querySelector('.mobile-facets__open-wrapper').click();
  });
}

class CustomSellingPlanSelector extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
    this.listClick = this.listClick.bind(this);
  }

  connectedCallback() {
    this.querySelector('.selling-plan-button').addEventListener('click', this.handleClick);
    this.querySelectorAll('.selling-plan-list-ul li').forEach((li) => {
      li.addEventListener('click', this.listClick);
    });
  }

  handleClick(event) {
    this.classList.toggle('active');
  }

  listClick(event) {
    this.classList.toggle('active');
    window.cartItemLoaderOn(this);
    const sellingPlanId = event.target.dataset.value;
    const qty = this.dataset.qty;
    const line = this.dataset.line;
    window.convertToSubscription(line, qty, sellingPlanId);
  }
}

customElements.define('custom-selling-plan-selector', CustomSellingPlanSelector);

window.convertToSubscription = async function (lineIndex, quantity, newSellingPlanId) {
  const data = {
    line: lineIndex,
    quantity: quantity,
    selling_plan: newSellingPlanId,
  };

  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((updatedCart) => {
      window.refreshCartDrawer(true);
    })
    .catch((error) => {
      console.error('Error updating selling plan:', error);
    });
};

document.addEventListener('DOMContentLoaded', (event) => {
  const header = document.querySelector('.shopify-section-group-header-group');
  let visibleHeaderHeight = 0;
  
  // Cache body reference
  const body = document.body;
  
  function updateCSSVariable() {
    body.style.setProperty('--custom-announcement-height', `${visibleHeaderHeight}px`);
  }

  function createObserver(target, onUpdate) {
    // Use fewer thresholds for better performance (every 10% instead of every 1%)
    const thresholds = Array.from({ length: 11 }, (_, i) => i / 10);
    
    const obs = new IntersectionObserver(
      (entries) => {
        // Use requestAnimationFrame to batch updates
        requestAnimationFrame(() => {
          for (let i = 0, len = entries.length; i < len; i++) {
            const entry = entries[i];
            const visibleHeight = entry.isIntersecting ? entry.boundingClientRect.height * entry.intersectionRatio : 0;
            onUpdate(visibleHeight);
            updateCSSVariable();
          }
        });
      },
      {
        root: null,
        threshold: thresholds,
      }
    );
    obs.observe(target);
  }

  // Observe header
  if (header) {
    createObserver(header, (height) => {
      visibleHeaderHeight = height;
    });
  }

  // Cache search input and product grid queries
  const searchInput = document.querySelector('.collection-main-right input[type="search"]');
  if (searchInput) {
    const productGridMain = document.querySelector('.collection-main-right #product-grid');
    if (productGridMain) {
      // Debounce search input for better performance
      let searchTimeout;
      searchInput.addEventListener('input', function () {
        clearTimeout(searchTimeout);
        searchTimeout = setTimeout(() => {
          window.collectionProductSearch(productGridMain, searchInput.value, true);
        }, 150);
      });
    }
  }
});

window.collectionProductSearch = function (productGridMain, query, triggerScroll) {
  // Cache DOM queries outside the loop
  const items = productGridMain.querySelectorAll('li.grid__item');
  const promoLists = productGridMain.querySelectorAll('.promo-list');
  const productNotFound = document.querySelector('.product-not-found');
  const queryLower = query.toLowerCase();
  const isEmpty = query === '';
  let visibleCount = 0;
  let totalWithTitle = 0;
  
  // Process promo lists once
  if (promoLists.length > 0) {
    const action = isEmpty ? 'remove' : 'add';
    promoLists.forEach((promoLi) => {
      promoLi.classList[action]('tw-hidden');
    });
  }
  
  // Use for loop for better performance
  for (let i = 0, len = items.length; i < len; i++) {
    const item = items[i];
    const title = item.dataset.title;
    
    if (title) {
      totalWithTitle++;
      if (isEmpty || title.toLowerCase().includes(queryLower)) {
        item.classList.remove('hidden');
        visibleCount++;
      } else {
        item.classList.add('hidden');
      }
    }
  }
  
  // Update product not found status once
  if (productNotFound) {
    if (totalWithTitle > 0 && visibleCount === 0) {
      productNotFound.classList.add('active');
    } else {
      productNotFound.classList.remove('active');
    }
  }

  if (triggerScroll) {
    // Use requestAnimationFrame for smoother scrolling
    requestAnimationFrame(() => {
      window.scrollBy(0, 1);
      window.scrollTo(0, 1);
    });
  }
};

class attachLoadMoreEvent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const productGrid = document.querySelector('#product-grid');
    const paginationWrapper = document.querySelector('#collectionAjaxinatePagination');

    function removeRechargeProductWidget() {
      document.querySelectorAll('.rc-container.rc_container').forEach((div) => {
        div.remove();
      });
    }

    const savedHTML = sessionStorage.getItem('collectionHTML');
    const scrollPosition = sessionStorage.getItem('scrollPosition');
    const lastLoadedPage = parseInt(sessionStorage.getItem('collectionPage') || '1', 10);
    let restoredFromSession = false;

    if (savedHTML && productGrid) {
      productGrid.innerHTML = savedHTML;
      restoredFromSession = true;

      setTimeout(() => {
        window.scrollTo(0, parseInt(scrollPosition || '0'));
        removeRechargeProductWidget();
        document.querySelectorAll('form[action="/cart/add"][data-stock="in-stock"]').forEach((form) => {
          form.setAttribute('data-recharge-loaded', 'false');
          form.setAttribute('data-onetime', 'false');
        });
      }, 500);

      sessionStorage.removeItem('collectionHTML');
      sessionStorage.removeItem('scrollPosition');
    }

    const injectNextPageLink = (pageNum) => {
      if (!paginationWrapper) return;

      const url = new URL(window.location.href);
      url.searchParams.set('page', pageNum);
      const nextURL = url.toString();

      paginationWrapper.innerHTML = `
        <a href="${nextURL}" class="pagination__next">Next</a>
      `;
    };

    let ajaxinate;
    if (restoredFromSession) {
      const nextPage = lastLoadedPage + 1;

      injectNextPageLink(nextPage);

      setTimeout(() => {
        ajaxinate = new Ajaxinate({
          container: '#product-grid',
          pagination: '#collectionAjaxinatePagination',
        });
      }, 500);
    } else {
      ajaxinate = new Ajaxinate({
        container: '#product-grid',
        pagination: '#collectionAjaxinatePagination',
      });
    }

    productGrid?.addEventListener('click', function (e) {
      const link = e.target.closest('a');
      if (link && this.contains(link)) {
        sessionStorage.setItem('collectionHTML', productGrid.innerHTML);
        sessionStorage.setItem('scrollPosition', window.scrollY.toString());

        const nextPageLink = paginationWrapper?.querySelector('a');
        if (nextPageLink) {
          const match = nextPageLink.href.match(/page=(\d+)/);
          if (match) {
            sessionStorage.setItem('collectionPage', (parseInt(match[1], 10) - 1).toString());
          }
        }
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', function () {
  customElements.define('attach-load-more-event', attachLoadMoreEvent);
});

window.cartItemLoaderOn = function (itemInnerEle) {
  const cartItem = itemInnerEle?.closest('.cart-item');
  if (!cartItem) return; // ← Prevent the error

  const loader = cartItem.querySelector('.cart-drawer-item__loader');
  loader?.classList.remove('hidden');
};